import { render, staticRenderFns } from "./faceCheck.vue?vue&type=template&id=66d88661&scoped=true"
import script from "./faceCheck.vue?vue&type=script&lang=js"
export * from "./faceCheck.vue?vue&type=script&lang=js"
import style0 from "./faceCheck.vue?vue&type=style&index=0&id=66d88661&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d88661",
  null
  
)

export default component.exports